const Spinner = () => (
  <div className="flex justify-center items-center space-x-2 my-2">
    <div className="w-12 h-12 border-4 border-dashed rounded-full animate-spin border-[#5d1f2a]"></div>
  </div>
);
export default Spinner;
